// extracted by mini-css-extract-plugin
export default {"mainContainer":"Design_mainContainer__kWYhk","innerHeading":"Design_innerHeading__McJ3j","description":"Design_description__jSocD","linksGrid":"Design_linksGrid__gdTu+"};